import React from "react";
import { LANGS } from "../lib/resolveLang";

export function LangSwitcher({ lang, setLang, accent = "sky", fullWidth = true, compact = false }) {
  const selected = accent === "amber" ? "bg-amber-500 text-black" : "bg-sky-500 text-white";
  const size = compact ? "px-1.5 py-1 text-[9px]" : "px-1 py-1 text-[10px]";

  return (
    <div
      className={`flex rounded-sm overflow-hidden border border-zinc-800 ${fullWidth ? "w-full" : ""}`}
    >
      {LANGS.map((l) => (
        <button
          key={l}
          type="button"
          data-testid={`lang-${l}`}
          onClick={() => setLang(l)}
          className={`${fullWidth ? "flex-1 min-w-0" : ""} ${size} font-mono uppercase ${
            lang === l ? selected : "bg-zinc-900 text-zinc-400"
          }`}
          aria-pressed={lang === l}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
